import { render } from "./Fotter.vue?vue&type=template&id=4bfa9e9e"
const script = {}

import "./Fotter.vue?vue&type=style&index=0&id=4bfa9e9e&lang=css"

import exportComponent from "C:\\yasukochi\\Work\\11_Marron\\00_Working\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__